import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Typography, FormGroup, FormControl, FormLabel, FormControlLabel, Checkbox, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, grey, red, yellow } from '@material-ui/core/colors';
import { toastr } from 'react-redux-toastr';
import { URL } from '../../assets/js/constants';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CreditCardIcon from '@material-ui/icons/CreditCard';


import { getRepassesAoVendedor, autorizarRepasseAoVendedor } from '../../store/actions/pagamentos';
import { getListaPerfilAdmin, atualizarPerfilUsuarioAdmin } from '../../store/actions/usuario';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import moedaBr from '../../assets/js/moedaBr';

const Repasses = props => {
    const history = useHistory();
    const {
        user,
        repassesAoVendedor,
        getRepassesAoVendedor,
        loading
    } = props;
    const { perfis } = user;

    const [toggleAdminAtualizarPerfilDialog, setToggleAdminAtualizarPerfilDialog] = useState(false);
    const [selectedPerfis, setSelectedPerfis] = useState('');
    const [usuarioNovoPerfil, setUsuarioNovoPerfil] = useState('');

    useEffect(_ => {
        getRepassesAoVendedor();
    }, [getRepassesAoVendedor]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: <>ID<br />Pedido</>,
            selector: (row) => row.pedidoId,
            width: '90px',
            sortable: true,
        },
        {
            name: 'Vendedor',
            selector: (row) => row.nomeVendedor,
            sortable: true,
        },
        {
            name: <>Valor do<br />Repasse</>,
            selector: (row) => moedaBr(row.valorLiquidoRepasse),
            sortable: true,
            width: '120px',
        },
        {
            name: <>Previsão para<br />Liberação</>,
            selector: (row) => row.dataPrevistaLiberacao,
            width: '120px',
        },
        {
            name: <>Data da<br />Liberação</>,
            selector: (row) => row.dataEfetivaTransferencia,
            width: '120px',
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.status === 1
                    ? (
                        <Tooltip title='Aguardando pagamento' placement='right'><CreditCardIcon style={{ color: yellow[500] }} /></Tooltip>
                    ) :
                    row.status === 2
                        ? (
                            <Tooltip title='Aguardando prazo de entrega' placement='right'><LocalShippingIcon style={{ color: yellow[700] }} /></Tooltip>
                        ) :
                        row.status === 3
                            ? (
                                <Tooltip title='Transferência solicitada' placement='right'><MonetizationOnIcon style={{ color: yellow[700] }} /></Tooltip>
                            ) :
                            row.status === 4
                                ? (
                                    <Tooltip title='Transferência realizada' placement='right'><MonetizationOnIcon style={{ color: green[500] }} /></Tooltip>
                                ) :
                                row.status === 5
                                    ? (
                                        <Tooltip title='Estorno realizado' placement='right'><MoneyOffIcon style={{ color: red[500] }} /></Tooltip>
                                    ) :
                                    row.status === 6
                                        ? (
                                            <Tooltip title='Em disputa' placement='right'><CancelIcon style={{ color: red[500] }} /></Tooltip>
                                        ) : (
                                            null
                                        )
            ),
            width: '100px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Detalhar Repasse' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="detalhar" size='small' color='secondary' onClick={() => handleDetalharRepasse(row.id)}><SearchOutlinedIcon /></IconButton>
                    </Tooltip>

                </>
            ),
            width: '100px'
        }
    ];

    const handleDetalharRepasse = (id) => {
        history.push({
            pathname: '/repasses-ao-vendedor/detalhar-repasse',
            state: {
                repasseId: id
            },
        });
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Repasses ao Vendedor' subtitulo={new Date().toLocaleString('pt-BR')} />

            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={repassesAoVendedor}
                    visibleSearch={repassesAoVendedor && repassesAoVendedor.length > 0}
                    camposParaBusca={['nomeVendedor', 'pedidoId', 'id']}
                />
            </Box>
        </>
    )
}

const mapStateToProps = state => ({
    user: state.auth.user,
    repassesAoVendedor: state.pagamentos.repassesAoVendedor,
    loading: state.pagamentos.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getRepassesAoVendedor,
    autorizarRepasseAoVendedor,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Repasses);